/* ==========================================================================
   EMIR PERSO v2 — personnalisation produit (1 ou 2 champs texte, choix, fichier) + chaîne compagnon
   Emir ICE / Gros-chien — thème Turbo. Remplace Infinite Options.

   Contexte mesuré le 2026-09-11 :
   - Bouton d'ajout « .ajax-submit » (type=button) dans <form action="/cart/add">.
   - Vanga smartcart écoute le clic sur DOCUMENT en capture et ajoute lui-même
     le produit : tout ce qui est posé sur le bouton arrive trop tard, et un
     produit « bundle » n'est jamais ajouté (c'était le bug d'Infinite Options).
   - Bouton de paiement dynamique présent : il saute toute validation.

   Parades :
   1. VERROU : bouton « disabled » tant qu'une personnalisation obligatoire
      manque. Un bouton désactivé n'émet aucun clic.
   2. GARDE : écouteur de clic sur WINDOW en capture (avant document/Vanga).
      Sur un produit avec chaîne, c'est NOUS qui ajoutons pendentif + chaîne
      en une requête /cart/add.js, puis on ouvre le tiroir Vanga.
   3. FICHIER : soumission native form.submit() (seul chemin multipart) ; la
      chaîne est alors posée « en attente » et ajoutée par emir-chaine-cart.js.
   Le bouton de paiement dynamique est masqué (CSS) sur ces formulaires.
   Interdit : MutationObserver sur le bouton (boucle avec la barre collante).
   ========================================================================== */
(function () {
  'use strict';

  var MAX_BYTES = 20 * 1024 * 1024;
  var OK_EXT = ['png', 'jpg', 'jpeg', 'webp', 'gif', 'svg', 'pdf', 'heic', 'heif'];
  var registry = []; /* une entrée par <form> */

  function humanSize(bytes) {
    if (bytes < 1024) return bytes + ' o';
    if (bytes < 1048576) return Math.round(bytes / 1024) + ' Ko';
    return (bytes / 1048576).toFixed(1).replace('.', ',') + ' Mo';
  }
  function extOf(name) {
    var i = String(name).lastIndexOf('.');
    return i === -1 ? '' : String(name).slice(i + 1).toLowerCase();
  }

  /* ---------- Argent ---------- */
  function formatMoney(cents, format) {
    format = String(format || '{{amount}}€').replace(/<[^>]*>/g, '');
    var m = /\{\{\s*(\w+)\s*\}\}/.exec(format);
    var key = m ? m[1] : 'amount';
    var value = Math.round(cents) / 100;
    var decimals = (key.indexOf('no_decimals') !== -1) ? 0 : 2;
    var fixed = value.toFixed(decimals);
    var parts = fixed.split('.');
    var thousands = ',', dec = '.';
    if (key.indexOf('comma_separator') !== -1) { thousands = '.'; dec = ','; }
    else if (key.indexOf('space_separator') !== -1) { thousands = ' '; dec = ','; }
    else if (key.indexOf('apostrophe_separator') !== -1) { thousands = "'"; dec = '.'; }
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    var out = decimals ? intPart + dec + parts[1] : intPart;
    return format.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  /* ---------- Produit courant (JSON posé par le thème) ---------- */
  function productOf(form) {
    var host = form.closest ? form.closest('[data-product-form]') : null;
    if (!host) return null;
    if (host.__emirProduct !== undefined) return host.__emirProduct;
    var p = null;
    try { p = JSON.parse(host.getAttribute('data-product') || 'null'); } catch (e) { p = null; }
    host.__emirProduct = p;
    return p;
  }
  function moneyFormatOf(form) {
    var host = form.closest ? form.closest('[data-product-form]') : null;
    return (host && host.getAttribute('data-money-format')) || '{{amount}}€';
  }
  function currentVariant(form) {
    var idEl = form.querySelector('select[name="id"], input[name="id"]');
    var id = idEl ? parseInt(idEl.value, 10) : NaN;
    var p = productOf(form);
    if (!p || !p.variants) return { id: id, variant: null };
    for (var i = 0; i < p.variants.length; i++) {
      if (p.variants[i].id === id) return { id: id, variant: p.variants[i] };
    }
    return { id: id, variant: null };
  }

  /* Nombre de lettres imposé par la variante (« 3 lettres », « Initiale simple ») */
  function lettersFromVariant(form) {
    var cv = currentVariant(form);
    var v = cv.variant;
    if (!v || !v.options) return null;
    for (var i = 0; i < v.options.length; i++) {
      var val = String(v.options[i] || '');
      var m = /(\d+)\s*lettre/i.exec(val);
      if (m) return parseInt(m[1], 10);
      if (/initiale/i.test(val)) return 1;
    }
    return null;
  }

  function entryFor(form) {
    for (var i = 0; i < registry.length; i++) if (registry[i].form === form) return registry[i];
    var e = {
      form: form,
      validators: [],
      errBoxes: [],
      roots: [],
      hasFile: function () { return false; },
      getChain: null,
      onChange: [],
      showErr: function (msg) {
        for (var k = 0; k < e.errBoxes.length; k++) {
          e.errBoxes[k].textContent = msg;
          e.errBoxes[k].classList.add('is-visible');
        }
        if (e.roots[0]) e.roots[0].classList.add('is-invalid');
      },
      clearErr: function () {
        for (var k = 0; k < e.errBoxes.length; k++) e.errBoxes[k].classList.remove('is-visible');
        for (var r = 0; r < e.roots.length; r++) e.roots[r].classList.remove('is-invalid');
      },
      validate: function () {
        for (var k = 0; k < e.validators.length; k++) {
          var msg = e.validators[k]();
          if (msg) return msg;
        }
        return null;
      },
      focusFirstEmpty: function () {
        var root = e.roots[0];
        if (!root) return;
        try { root.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (x) { root.scrollIntoView(); }
        var ts = root.querySelectorAll('[data-bv-perso-text]');
        for (var i = 0; i < ts.length; i++) { if (!ts[i].value.trim()) { try { ts[i].focus({ preventScroll: true }); } catch (x) { ts[i].focus(); } break; } }
      }
    };
    /* ---------- VERROU ---------- (jamais de MutationObserver ici) */
    var gating = false, weDisabled = false;
    e.applyGate = function () {
      if (gating) return;
      gating = true;
      try {
        var invalid = !!e.validate();
        var buttons = form.querySelectorAll('button[name="add"], input[name="add"]');
        Array.prototype.forEach.call(buttons, function (b) {
          if (invalid) {
            if (!b.disabled) { b.disabled = true; weDisabled = true; }
            if (b.getAttribute('aria-disabled') !== 'true') b.setAttribute('aria-disabled', 'true');
            b.classList.add('bv-perso-locked');
          } else if (weDisabled) {
            b.disabled = false;
            b.removeAttribute('aria-disabled');
            b.classList.remove('bv-perso-locked');
          }
        });
        if (!invalid) weDisabled = false;
        for (var r = 0; r < e.roots.length; r++) e.roots[r].classList.toggle('is-locked', invalid);
      } finally { gating = false; }
    };
    form.classList.add('bv-perso-form');
    form.setAttribute('enctype', 'multipart/form-data');
    /* Le thème réactive le bouton et change la variante via jQuery : on
       réévalue sur les événements natifs du formulaire + une passe différée. */
    form.addEventListener('change', function () {
      setTimeout(function () {
        for (var k = 0; k < e.onChange.length; k++) e.onChange[k]();
        e.applyGate();
      }, 0);
    });
    form.addEventListener('input', function () { e.clearErr(); });
    setTimeout(e.applyGate, 1500);
    registry.push(e);
    return e;
  }

  /* ==================== PERSONNALISATION (texte(s) / choix / fichier) ==================== */
  function initPerso(root) {
    if (root.getAttribute('data-bv-perso-ready') === '1') return;
    root.setAttribute('data-bv-perso-ready', '1');
    var form = root.closest ? root.closest('form') : null;
    if (!form) return;
    var e = entryFor(form);
    e.roots.push(root);

    var textInputs = Array.prototype.slice.call(root.querySelectorAll('[data-bv-perso-text]'));
    var choice = root.querySelector('[data-bv-perso-choice]');
    var fileInput = root.querySelector('[data-bv-perso-file]');
    var errBox = root.querySelector('[data-bv-perso-err]');
    var drop = root.querySelector('[data-bv-perso-drop]');
    var dropName = root.querySelector('[data-bv-perso-name]');
    var dropDefault = dropName ? dropName.textContent : '';
    var rootRequired = root.getAttribute('data-required') === 'true';
    if (errBox) e.errBoxes.push(errBox);

    function hasFile() { return !!(fileInput && fileInput.files && fileInput.files.length); }
    e.hasFile = hasFile;

    /* Chaque champ texte : compteur propre, maximum propre, obligatoire propre.
       Seul le champ « primary » suit la variante « N lettres ». */
    function fieldOf(input) {
      var wrap = input.closest ? input.closest('.bv-perso__field') : null;
      return {
        input: input,
        required: input.getAttribute('data-req') === 'true',
        primary: input.hasAttribute('data-bv-perso-primary'),
        maxDefault: parseInt(input.getAttribute('data-max-default'), 10) || parseInt(root.getAttribute('data-max-default'), 10) || 30,
        counter: wrap ? wrap.querySelector('[data-bv-perso-count]') : null,
        counterWrap: wrap ? wrap.querySelector('[data-bv-perso-countwrap]') : null,
        maxLabel: wrap ? wrap.querySelector('[data-bv-perso-max]') : null,
        label: wrap && wrap.querySelector('.bv-perso__label') ? wrap.querySelector('.bv-perso__label').textContent.replace('*', '').trim() : 'personnalisation'
      };
    }
    var fields = textInputs.map(fieldOf);

    function currentMax(f) {
      if (f.primary) { var n = lettersFromVariant(form); if (n) return n; }
      return f.maxDefault;
    }
    function refreshCount(f) {
      if (!f.counter) return;
      var max = parseInt(f.input.getAttribute('maxlength'), 10) || 0;
      f.counter.textContent = String(f.input.value.length);
      if (f.counterWrap) f.counterWrap.classList.toggle('is-full', !!max && f.input.value.length >= max);
    }
    function applyMax(f) {
      var max = currentMax(f);
      f.input.setAttribute('maxlength', String(max));
      if (f.input.value.length > max) f.input.value = f.input.value.slice(0, max);
      if (f.maxLabel) f.maxLabel.textContent = String(max);
      refreshCount(f);
    }
    function applyAllMax() { fields.forEach(applyMax); }

    e.validators.push(function () {
      if (rootRequired && choice && !choice.value) return 'Merci de faire votre choix (' + (choice.previousElementSibling ? choice.previousElementSibling.textContent.replace('*', '').trim() : 'option') + ') avant d’ajouter au panier.';
      for (var i = 0; i < fields.length; i++) {
        var f = fields[i];
        if (f.required && !f.input.value.trim()) return 'Merci de renseigner « ' + f.label + ' » avant d’ajouter au panier.';
        if (f.primary) {
          var n = lettersFromVariant(form);
          if (n && f.input.value.trim().length > n) return 'La variante choisie permet ' + n + ' caractère' + (n > 1 ? 's' : '') + ' maximum.';
        }
      }
      if (rootRequired && fileInput && !hasFile()) return 'Merci de joindre votre visuel avant d’ajouter au panier.';
      return null;
    });
    e.onChange.push(applyAllMax);

    function refreshFile() {
      if (!fileInput || !drop) return;
      var f = fileInput.files && fileInput.files[0];
      if (!f) {
        drop.classList.remove('is-filled');
        if (dropName) dropName.textContent = dropDefault;
        e.applyGate(); return;
      }
      if (f.size > MAX_BYTES) {
        fileInput.value = ''; drop.classList.remove('is-filled');
        if (dropName) dropName.textContent = dropDefault;
        e.showErr('Fichier trop lourd (' + humanSize(f.size) + '). Maximum accepté : 20 Mo.');
        e.applyGate(); return;
      }
      if (OK_EXT.indexOf(extOf(f.name)) === -1) {
        fileInput.value = ''; drop.classList.remove('is-filled');
        if (dropName) dropName.textContent = dropDefault;
        e.showErr('Format non accepté. Envoyez une image (JPG, PNG, WEBP, SVG) ou un PDF.');
        e.applyGate(); return;
      }
      e.clearErr();
      drop.classList.add('is-filled');
      if (dropName) dropName.textContent = f.name + ' — ' + humanSize(f.size);
      e.applyGate();
    }

    fields.forEach(function (f) {
      f.input.addEventListener('input', function () { refreshCount(f); e.clearErr(); e.applyGate(); });
      applyMax(f);
    });
    if (choice) choice.addEventListener('change', function () { e.clearErr(); });
    if (fileInput) { fileInput.addEventListener('change', refreshFile); refreshFile(); }
    if (drop && fileInput) {
      ['dragenter', 'dragover'].forEach(function (evt) {
        drop.addEventListener(evt, function (ev) { ev.preventDefault(); ev.stopPropagation(); drop.classList.add('is-over'); });
      });
      ['dragleave', 'drop'].forEach(function (evt) {
        drop.addEventListener(evt, function (ev) { ev.preventDefault(); ev.stopPropagation(); drop.classList.remove('is-over'); });
      });
      drop.addEventListener('drop', function (ev) {
        var dt = ev.dataTransfer;
        if (dt && dt.files && dt.files.length) {
          try { fileInput.files = dt.files; } catch (err) { return; }
          refreshFile();
        }
      });
    }
    e.applyGate();
  }

  /* ==================== CHAÎNE COMPAGNON ==================== */
  function initChaine(root) {
    if (root.getAttribute('data-emir-chaine-ready') === '1') return;
    root.setAttribute('data-emir-chaine-ready', '1');
    var form = root.closest ? root.closest('form') : null;
    if (!form) return;
    var e = entryFor(form);
    e.roots.push(root);

    var models = root.querySelectorAll('[data-emir-chaine-model]');
    var groups = root.querySelectorAll('[data-emir-lengths]');
    var prop = root.querySelector('[data-emir-chaine-prop]');
    var totalWrap = root.querySelector('[data-emir-chaine-total]');
    var totalVal = root.querySelector('[data-emir-chaine-total-value]');
    var errBox = root.querySelector('[data-emir-chaine-err]');
    if (errBox) e.errBoxes.push(errBox);

    function currentModel() {
      for (var i = 0; i < models.length; i++) if (models[i].checked) return models[i].value;
      return models[0] ? models[0].value : '';
    }
    function groupFor(model) {
      for (var i = 0; i < groups.length; i++) if (groups[i].getAttribute('data-emir-lengths') === model) return groups[i];
      return null;
    }
    function chosen() {
      var g = groupFor(currentModel());
      return g ? g.querySelector('input[data-emir-chaine-variant]:checked') : null;
    }
    function refresh() {
      var model = currentModel();
      Array.prototype.forEach.call(models, function (m) {
        var lab = m.closest('label');
        if (lab) lab.classList.toggle('is-selected', m.checked);
      });
      Array.prototype.forEach.call(groups, function (g) {
        g.hidden = g.getAttribute('data-emir-lengths') !== model;
        Array.prototype.forEach.call(g.querySelectorAll('input[data-emir-chaine-variant]'), function (inp) {
          var lab = inp.closest('label');
          if (lab) lab.classList.toggle('is-selected', inp.checked);
        });
      });
      var c = chosen();
      if (prop) prop.value = c ? c.getAttribute('data-label') : '';
      /* total pendentif + chaîne */
      var cv = currentVariant(form);
      if (totalWrap && totalVal && c && cv.variant && typeof cv.variant.price === 'number') {
        var qtyEl = form.querySelector('input[name="quantity"]');
        var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
        var total = (cv.variant.price + (parseInt(c.getAttribute('data-price'), 10) || 0)) * qty;
        totalVal.textContent = formatMoney(total, moneyFormatOf(form));
        totalWrap.hidden = false;
      } else if (totalWrap) {
        totalWrap.hidden = true;
      }
    }
    root.addEventListener('change', function () { setTimeout(refresh, 0); });
    e.onChange.push(refresh);
    e.validators.push(function () { return chosen() ? null : 'Merci de choisir la longueur de ta chaîne.'; });
    e.getChain = function () {
      var c = chosen();
      if (!c) return null;
      return {
        id: parseInt(c.value, 10),
        price: parseInt(c.getAttribute('data-price'), 10) || 0,
        label: c.getAttribute('data-label') || ''
      };
    };
    refresh();
    e.applyGate();
  }

  /* ==================== AJOUT AU PANIER (pendentif + chaîne) ==================== */
  function collectProperties(form) {
    var props = {};
    Array.prototype.forEach.call(form.querySelectorAll('[name^="properties["]'), function (el) {
      if (el.type === 'file') return;
      if (el.closest && el.closest('#infiniteoptions-container')) return; /* reliquat Infinite Options */
      if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) return;
      var m = /^properties\[(.+)\]$/.exec(el.name);
      if (!m) return;
      var v = String(el.value || '').trim();
      if (v !== '') props[m[1]] = v;
    });
    return props;
  }
  function newKey() { return 'c' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7); }

  function setBusy(button, busy) {
    if (!button) return;
    var txt = button.querySelector('.text') || button;
    if (busy) {
      if (button.__emirLabel === undefined) button.__emirLabel = txt.textContent;
      txt.textContent = 'Ajout en cours…';
      button.disabled = true;
      button.classList.add('emir-busy');
    } else {
      if (button.__emirLabel !== undefined) txt.textContent = button.__emirLabel;
      button.disabled = false;
      button.classList.remove('emir-busy');
    }
  }
  function flash(button, label) {
    if (!button) return;
    var txt = button.querySelector('.text') || button;
    var old = txt.textContent;
    txt.textContent = label;
    button.classList.add('emir-added');
    setTimeout(function () { txt.textContent = old; button.classList.remove('emir-added'); }, 2200);
  }

  function afterAdd(button) {
    setBusy(button, false);
    flash(button, 'Ajouté au panier ✓');
    try { document.dispatchEvent(new CustomEvent('emir:cart:added')); } catch (x) {}
    if (window.Vanga && typeof window.Vanga.refresh === 'function') {
      try { window.Vanga.refresh(); } catch (x) {}
      if (typeof window.Vanga.open === 'function') { try { window.Vanga.open(); } catch (x) {} }
      return;
    }
    window.location.href = '/cart';
  }

  function addWithChain(e, button) {
    var form = e.form;
    var cv = currentVariant(form);
    if (!cv.id) { e.showErr('Sélectionne d’abord une variante.'); return; }
    var qtyEl = form.querySelector('input[name="quantity"]');
    var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
    var chain = e.getChain();
    var key = newKey();
    var p = productOf(form);
    var props = collectProperties(form);
    props._emir_bundle = key;
    var items = [{ id: cv.id, quantity: qty, properties: props }];
    if (chain) {
      items.push({ id: chain.id, quantity: qty, properties: { _emir_chaine_pour: key, 'Pour': (p && p.title) || 'pendentif' } });
    }
    setBusy(button, true);
    e.clearErr();
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, body: j }; }, function () { return { ok: r.ok, body: null }; });
    }).then(function (res) {
      if (!res.ok) {
        var msg = (res.body && (res.body.description || res.body.message)) || 'erreur inconnue';
        throw new Error(msg);
      }
      afterAdd(button);
    }).catch(function (err) {
      setBusy(button, false);
      e.showErr('Impossible d’ajouter au panier : ' + err.message);
    });
  }

  /* ---------- GARDE : window, phase de capture (avant Vanga / thème) ---------- */
  function findEntry(form) {
    for (var i = 0; i < registry.length; i++) if (registry[i].form === form) return registry[i];
    return null;
  }
  function windowGuard(ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var trigger = t.closest('[name="add"], .add_to_cart, .ajax-submit, .shopify-payment-button');
    if (!trigger) return;
    var form = trigger.closest ? trigger.closest('form') : null;
    var e = form ? findEntry(form) : null;
    if (!e) return;

    var msg = e.validate();
    if (msg) {
      ev.preventDefault(); ev.stopImmediatePropagation();
      e.showErr(msg); e.focusFirstEmpty();
      return false;
    }
    if (e.hasFile()) {
      /* Fichier joint : POST natif multipart, la chaîne suit après rechargement. */
      ev.preventDefault(); ev.stopImmediatePropagation();
      var chain = e.getChain ? e.getChain() : null;
      if (chain) {
        var key = newKey();
        var qtyEl = e.form.querySelector('input[name="quantity"]');
        var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
        var hidden = document.createElement('input');
        hidden.type = 'hidden'; hidden.name = 'properties[_emir_bundle]'; hidden.value = key;
        e.form.appendChild(hidden);
        var p = productOf(e.form);
        try { window.sessionStorage.setItem('emir_pending_chain', JSON.stringify({ id: chain.id, qty: qty, key: key, title: (p && p.title) || '' })); } catch (x) {}
      }
      e.form.setAttribute('enctype', 'multipart/form-data');
      e.form.submit();
      return false;
    }
    if (e.getChain && e.getChain()) {
      ev.preventDefault(); ev.stopImmediatePropagation();
      addWithChain(e, trigger.closest('button, input') || trigger);
      return false;
    }
    /* Personnalisation texte seule : le flux normal du thème / des apps
       transporte déjà les propriétés du formulaire. */
  }
  window.addEventListener('click', windowGuard, true);
  window.addEventListener('submit', function (ev) {
    var e = findEntry(ev.target);
    if (!e) return;
    var msg = e.validate();
    if (msg) {
      ev.preventDefault(); ev.stopImmediatePropagation();
      e.showErr(msg); e.focusFirstEmpty();
      return false;
    }
  }, true);

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bv-perso]'), initPerso);
    Array.prototype.forEach.call(document.querySelectorAll('[data-emir-chaine]'), initChaine);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('page:load', boot);
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('quickshop:loaded', boot);
  if (window.InstantClick && typeof window.InstantClick.on === 'function') window.InstantClick.on('change', boot);
  /* Quick shop Turbo : le formulaire arrive après coup, on repasse un peu plus tard. */
  setTimeout(boot, 1200);
  setTimeout(boot, 3000);
})();
